<template>
  <!-- 个人中心 订单详情列表 -->
  <div id="ask-order">
    <!-- title -->
    <div class="top-title">
      <img
        src="../../assets/img/login-img/3-1档案-返回ic@2x.png"
        alt=""
        class="back-icon"
        @click="goBack"
      >
      <p class="title-text">我的医生</p>
      <p class="right-text" v-show="isDelect" @click="isDelect = false">完成</p>
      <div v-if="likeList.length>0">
        <img
          src="../../assets/img/login-img/3-3file-delectic@2x.png"
          alt=""
          class="right-icon"
          @click="isDelect = true"
          v-show="!isDelect"
        >
      </div>
    </div>
    <!-- end -->
    <div class="nav-item">
      <van-tabs v-model="tabActive" swipeable color="#37bd37" title-active-color="#37bd37" @change="changeType">
        <van-tab title="收藏">1</van-tab>
        <van-tab title="浏览">2</van-tab>
        <van-tab title="咨询">3</van-tab>
      </van-tabs>
    </div>
    <div class="order-scroll" ref="orderScrollRef">
      <!-- <ul class="order-wrapper" @touchmove="handleTouchMove"> -->
      <ul class="order-wrapper">
        <li v-for="(item ,index) in likeList" :key="index" class="item-box mylike">
          <div class="content-box">
            <div class="select-button-box" v-show="isDelect" @click="onClick(item,index)">
              <img
                src="../../assets/img/login-img/3-4file-select@2x.png"
                alt=""
                class="select-button"
                v-show="delectList.includes(item.fid)"
              >
              <img
                src="../../assets/img/login-img/3-4file-noselect.png"
                alt=""
                class="select-button"
                v-show="!delectList.includes(item.fid)"
              >
            </div>
            <div class="box-wrapper" @click="goRouter2('/SdDoctorMsg',item.doctor_id)">
              <div class="order-box mylike">
                <div
                  class="goAsk"
                  @click.stop="goRouter('/SdInquiry',item.doctor_id)"
                  v-show="!isDelect"
                >去咨询</div>
                <div class="order-bottom">
                  <div class="order-icon">
                    <div v-if="item.num>0" class="number-box">
                      <span>{{item.num}}</span>
                    </div>
                    <img :src="item.image | imgUrl" alt="" class="order-icon order-icon-img">
                  </div>
                  <div class="order-msg">
                    <div class="order-doctor">
                      <span class="doctor-name">{{item.name || item.xz_doctor_name}}</span>
                      <span
                        class="doctor-good"
                        v-if="item.is_famous_doctor==='y'"
                      >{{item.is_famous_doctor}}</span>
                      <span class="clinicname">{{item.clinic_name}} {{item.title}}</span>
                    </div>
                    <div class="order-replay">{{item.hospital}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 缺省页 -->
    <div class="null-wrapper" v-if="likeList.length===0 && showNull">
      <div class="img-wrapper">
        <img src="../../assets/img/queshengye/no-item@2x.png" alt="" class="null-img">
      </div>
      <div class="text-wrapper">
        <span class="null-text" v-if="doctorType==1">暂无喜欢的医生，快去收藏吧~</span>
        <span class="null-text" v-if="doctorType==2">暂无看过的医生，快去浏览吧~</span>
        <span class="null-text" v-if="doctorType==3">暂无问过的医生，快去咨询吧~</span>
      </div>
      <div class="button-wrapper">
        <van-button class="null-button" type="primary" @click="goAsk('/SdAskDoctor')">医生列表</van-button>
      </div>
    </div>
    <!-- end -->
    <!-- bottom -->
    <div class="bottom-button" v-if="isDelect">
      <div class="bottom-left" v-show="true" @click="allSelect">
        <img
          src="../../assets/img/login-img/3-4file-noselect.png"
          alt=""
          class="select-icon"
          v-show="!allSelectFlag"
        >
        <img
          src="../../assets/img/login-img/3-4file-select@2x.png"
          alt=""
          class="select-icon"
          v-show="allSelectFlag"
        >
        <p class="select-text siyuan-bold">全选</p>
      </div>
      <div class="bottom-right">
        <van-button size="large" class="right-button" @click="onSubmit">取消收藏</van-button>
      </div>
    </div>
    <!-- end -->
    <div class="bottom-text" v-if="showBottom">
      <span>深读医生等着你来问，music!</span>
    </div>
  </div>
</template>

<script>
  import BScroll from "better-scroll";
  import { Tab, Tabs } from "vant";
  import api from '@/api/index'
  // import Vue from "Vue";
  export default {
    data() {
      return {
        isDelect: false,
        likeList: [],
        delectList: [],
        allSelectFlag: false,
        showPay: false, // 控制从新支付提示
        order_number: "",
        orderItem: {},
        showBottom: false,
        showNull: false,
        backPath: "",
        orderScroll: null,
        likeParams: {
          page: 1,
          number: 5
        },
        tabActive: 0,
        doctorType: 1
      };
    },
    updated() {
      // this.showTips()
    },
    beforeMount() {
      this.fetch();
      this.showTips();
    },
    mounted() {
      //alert(localStorage.getItem("token"))
      this.$nextTick(() => {
        this.initScroll();
      });
    },
    beforeRouteLeave(to, from, next) {
      if (to.path === "/SdInquiry") {
        this.backPath = "/SdAskDoctor";
        // this.$router.push('/SdAskDoctor')
        next();
      } else {
        next();
      }
      if (to.path === "/SdAskOrder") {
        this.backPath = "/SdUserInfo";
        // this.$router.push('/SdUserInfo')
        next();
      } else {
        next();
      }
    },
    methods: {
      changeType(name, title) {
        this.likeParams.page = 1
        this.likeParams.number = 5
        this.doctorType = name+1
        this.likeList = []
        this.isDelect = false
        this.fetch()
      },
      // 初始化滚动
      initScroll() {
        const options = {
          click: true,
          // pullDownRefresh: {},
          probeType: 2
        };
        options.pullUpLoad = {
          threshold: -90,
          stop: -20
        };
        this.orderScroll = new BScroll(this.$refs.orderScrollRef, options);
        this.orderScroll.on("pullingUp", () => {
          this.pagingSearch();
          this.orderScroll.finishPullUp();
        });
      },
      // 分页
      pagingSearch() {
        this.likeParams.page++;
        this.fetch();
      },
      goBack() {
        if (this.$route.query.from) {
          this.$router.push(this.$route.query.from);
        } else if (this.backPath) {
          this.$router.push(this.backPath);
        } else {
          this.$router.push("/SdUserInfo");
        }
      },
      fetch(val) {
        let params = {
          type: this.doctorType
        }
        // let url = `/center/doctor_list?page=${this.likeParams.page}&number=${this.likeParams.number}`;
        let url = `${api.collectDoctorList}?type=${params.type}&page=${this.likeParams.page}&number=${this.likeParams.number}`;
        const toast = this.$toast({
          mask: true,
          message: "正在加载...",
          duration: 600
        });
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            // toast.clear();
            if (res.data.totalPage > 0) {
              if (this.likeParams.page > res.data.totalPage) {
                this.$toast("已经是最后一页了~");
              } else {
                let arry = res.data.data;
                this.likeList = this.likeList.concat(arry);
                if (val === "delete") {
                  this.orderScroll.scrollTo(0, 0);
                } else {
                  // this.orderScroll.scrollTo(0, this.orderScroll.maxScrollY);
                }
              }
            } else {
              toast.clear();
              this.likeList = res.data.data;
              this.showNull = true;
            }
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      allSelect() {
        this.allSelectFlag = !this.allSelectFlag;
        if (this.allSelectFlag) {
          this.delectList.splice(0);
          this.likeList.map((item, index) => {
            this.delectList.push(item.fid);
          });
        } else {
          this.delectList.splice(0);
        }
      },
      onSubmit() {
        // let url = "/center/doctor_collect_delete";
        let url = api.deleteCollectDoctor
        let self = this;
        // let params = { doctor_id: this.delectList};
        // let params = this.delectList.map(function (val, index) {
        //   return Number(val)
        // })
        // this.delectList.map(function(val, index) {
        //   let params = { "doctor_id[]": Number(val) };
        //   self.$http.post(url, self.$ObjToFd(params)).then(res => {
        //     if (res.data.code == 0) {
        //       self.$toast("取消收藏成功");
        //       self.likeParams.page = 1;
        //       self.likeList = [];
        //       self.fetch("delete");
        //       self.delectList = [];
        //       self.allSelectFlag = false;
        //       self.isDelect = false;
        //     } else {
        //       self.$toast(res.data.message);
        //     }
        //   });
        // });
        let params = {"fids": this.delectList }
        console.log(this.delectList)
        self.$http.post(url, self.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            self.$toast("取消收藏成功");
            self.likeParams.page = 1;
            self.likeList = [];
            self.fetch("delete");
            self.delectList = [];
            self.allSelectFlag = false;
            self.isDelect = false;
          } else {
            self.$toast(res.data.message);
          }
        });
      },
      onClick(item) {
        // let flag = this.delectList.indexOf(item.doctor_id);
        // if (flag === -1) {
        //   this.delectList.push(item.doctor_id);
        // } else {
        //   this.delectList.splice(flag, 1);
        // }
        let flag = this.delectList.indexOf(item.fid);
        if (flag === -1) {
          this.delectList.push(item.fid);
        } else {
          this.delectList.splice(flag, 1);
        }
      },
      goRouter2(val, item) {
        this.$router.push({ path: val, query: { doctorId: item } });
      },
      goRouter(val, item) {
        this.$router.push({ path: val, query: { doctor_id: item } });
      },
      goAsk(val) {
        this.$router.push(val);
      },
      // dialog关闭之前
      beforeClose(action, done) {
        if (action === "confirm") {
          this.payMoney();
          done();
        } else {
          done();
        }
      },
      // 微信支付
      payMoney() {
        let params = {
          order_amount: 1,
          order_number: this.orderItem.order_number,
          openid: localStorage.getItem("openid"),
          cxzf: "y"
        };
        let that = this;
        let url = api.createOrder;
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            // 下单成功，调用微信支付js
            this.orderNum = res.data.data.order_number;
            this.http = res.data.data.config.json;
            this.prepayId = res.data.data.config.prepayId;
            let params = {
              appId: this.http.appId,
              nonceStr: this.http.nonceStr,
              package: this.http.package,
              paySign: this.http.paySign,
              signType: this.http.signType,
              timeStamp: this.http.timeStamp
            };
            if (this.prepayId !== "") {
              // eslint-disable-next-line
              WeixinJSBridge.invoke("getBrandWCPayRequest", params, function(
                res
              ) {
                if (res.err_msg === "get_brand_wcpay_request:ok") {
                  // 如果订单的ask_group_type=1 创建总包问题
                  if (that.orderItem.ask_group_type === "1") {
                    that.creatZbSecond();
                    this.fetch();
                  } else {
                    this.creatDxSecond();
                    this.fetch();
                  }
                } else {
                  this.$toast("支付失败");
                }
              });
            }
          }
        });
      },
      // 创建总包从新支付
      creatZbSecond() {
        let url = api.createPaidProblemSecond;
        let params = {
          order_number: this.orderItem.order_number
        };
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == "0") {
            this.$router.push({
              path: "/SdAskChat",
              query: { orderId: this.order_number }
            });
          }
        });
      },
      // 创建定向从新支付
      creatDxSecond() {
        let url = api.createPaidProblemSecond;
        let params = {
          order_number: this.orderItem.order_number,
          xz_doctor_id: this.orderItem.xz_doctor_id
        };
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == "0" || res.data.code == 0) {
            this.$toast("定向重新支付成功");
            this.$router.push({
              path: "/SdAskChat",
              query: { orderId: this.order_number }
            });
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      //
      showTips() {
        this.showBottom = document.documentElement.scrollTop > 0;
      },
      // 未支付前往从新支付页面
      rePay(item) {
        this.$router.push({
          path: "/SdInquiry",
          query: { order_number: item.order_number }
        });
      }
    },
    computed: {
      defaultImg() {
        return require("../../assets/img/order-img/default-img.png");
      }
    },
    filters: {
      imgUrl(val) {
        return val || require("../../assets/img/order-img/no-pay.png");
      },
      imgIng(val) {
        if (val.xz_doctor_image || val.doctor_image) {
          return val.xz_doctor_image || val.doctor_image;
        } else {
          return require("../../assets/img/order-img/default-img.png");
        }
      }
    }
  };
</script>

<style lang="postcss">
  #ask-order {
    height: 100%;
    background-color: #fffffd;
    width: 100%;
    
    & .top-title {
      position: relative;
      width: 100%;
      padding: 27px 0;
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 999;
      display: flex;
      justify-content: center;
      background-color: #fffffd;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      &::after {
        position: absolute;
        bottom: 0;
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        border: 1px solid rgba(215, 215, 215, 1);
        transform: scaleY(0.3);
      }
      & .back-icon {
        width: 17px;
        height: 34px;
        position: absolute;
        left: 30px;
      }
      & .title-text {
        font-size: 34px;
        font-family: "SourceHanSansCN Medium";
        font-weight: 400;
      }
      & .right-text {
        position: absolute;
        right: 30px;
        color: #37bd37;
      }
      & .right-icon {
        position: absolute;
        right: 30px;
        width: 32px;
        height: 32px;
      }
    }
    & .nav-item {
      width: 100%;
      position: fixed;
      top: -1px;
      z-index: 1;
      & .van-tabs__wrap {
        height: 88px;
        & .van-tab {
          line-height: 100px;
          & .van-ellipsis {
            font-size: 28px !important;
          }
        }
      }
      & .van-tab__pane {
        font-size: 0;
      }
    }
    & .order-scroll {
      position: absolute;
      top: 176px;
      width: 100%;
      height: 90%;
      overflow: hidden;
    }
    & .order-wrapper {
      /* position: relative; */
      /* position: absolute; */
      width: 100%;
      /* height: 100%; */
      /* margin-top: 88px; */
      padding: 0 30px;
      box-sizing: border-box;
      overflow: hidden;
      /* display: inline-block; */
      padding-bottom: 100px;
      & .item-box.mylike {
        margin-top: 40px;
      }
      & .box-wrapper {
        width: 100%;
      }
    }
    & .content-box {
      display: flex;
      align-items: center;
      display: flex;
      width: 100%;
      & .select-button-box {
        & .select-button {
          width: 40px;
          margin-right: 45px;
        }
      }
      & .order-box.mylike::after {
        position: absolute;
        bottom: 0;
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        border: 1px solid rgba(215, 215, 215, 1);
        transform: scaleY(0.3);
      }
      & .order-box.mylike {
        position: relative;
        box-sizing: border-box;
        /* padding: 20px; */
        background: rgba(255, 255, 255, 1);
        box-shadow: none;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        height: 168px;
        & .goAsk {
          position: absolute;
          top: 64px;
          right: 0;
          color: #f4a000;
          border: 2px solid;
          border-radius: 30px;
          font-size: 26px;
          padding: 8px 15px;
        }
        & .order-bottom {
          /* padding: 20px; */
          padding: 0 30px;
          margin-top: 30px;
          display: flex;
          align-items: center;
          & .number-box {
            position: absolute;
            background-color: red;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            font-size: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: white;
          }
          & .order-icon {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            /* border: 1px solid #333; */
            /* overflow: hidden; */
            /* background-color: red; */
            margin-right: 30px;
          }
          & .order-icon-img {
            border: 1px solid #ddd;
          }
          & .order-msg {
            width: 400px;
            & .order-doctor {
              display: flex;
              align-items: center;
              & .doctor-name {
                font-size: 30px;
                font-family: SourceHanSansCN-Bold;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
              }
              & .doctor-good {
                font-size: 18px;
                color: rgba(255, 208, 49, 1);
                background: rgba(255, 208, 49, 0.1);
                border-radius: 8px;
                margin-left: 10px;
              }
              & .clinicname {
                color: #999;
                font-size: 26px;
                margin-left: 20px;
              }
            }
            & .order-replay {
              font-size: 28px;
              color: rgba(51, 51, 51, 1);
              margin-top: 20px;
              font-family: Source Han Sans CN;
              line-height: 35px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              /*! autoprefixer: off */
              -webkit-box-orient: vertical;
              /* autoprefixer: on */
              -webkit-line-clamp: 2;
            }
          }
        }
      }
    }
    & .null-wrapper {
      display: flex;
      flex-direction: column;
      padding-top: 202px;
      align-items: center;
      & .img-wrapper {
        & .null-img {
          width: 330px;
          height: 330px;
        }
      }
      & .text-wrapper {
        padding-top: 60px;
        font-size: 30px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
      & .button-wrapper {
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        padding-top: 50px;
        & .null-button {
          height: 88px;
          width: 100%;
          background: rgba(255, 255, 253, 1);
          border: 1px solid rgba(215, 215, 215, 1);
          box-shadow: 0px 0px 0px rgba(5px, 5px, 5px, 0.08);
          border-radius: 40px;
          font-size: 32px;
          font-family: SourceHanSansCN-Medium;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    & .bottom-button {
      width: 100%;
      height: 88px;
      position: fixed;
      bottom: 0;
      margin-top: 88px;
      display: flex;
      border: none;
      background-color: #fffffd;
      z-index: 999999;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      & .van-button--default {
        background-color: #fffffd;
        border: none;
      }
      & .bottom-left {
        border-right: 1px solid #d7d7d7;
        font-size: 32px;
        color: #666666;
        width: 220px;
        display: flex;
        align-items: center;
        padding-left: 30px;
        & .select-icon {
          margin-right: 20px;
          width: 40px;
        }
      }
      & .bottom-right {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        & .right-button {
          font-size: 32px;
          color: #37bd19;
          height: 100%;
        }
      }
    }
    & .activeDelect {
      margin: 0 30px;
    }
    & .onDelete {
      margin-bottom: 50px;
    }
    & .bottom-text {
      font-size: 24px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 180px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduUserInfo/SdLikeDoctor.vue